import { Vue, Component } from 'vue-property-decorator'
import HeaderComponent from '@/components/header'
import FooterComponent from '@/components/footer'
import NavigationComponent from '@/components/navigation'

@Component({
  components: {
    HeaderComponent,
    FooterComponent,
    NavigationComponent
  }
})
export default class App extends Vue {
  private NavIsOpen = false

  private navIsOpen (val: boolean): void {
    this.NavIsOpen = val
  }
}
